import React, { useState, useEffect } from "react"

const ScrollPos = ({ render }) => {
  const [scrollPosition, setScrollPosition] = useState(0)

  useEffect(() => {
    updateScrollPosition()
    window.addEventListener("scroll", updateScrollPosition)

    return () => {
      window.removeEventListener("scroll", updateScrollPosition)
    }
  }, [])

  const updateScrollPosition = () => {
    if (window.pageYOffset > 77) {
      return
    }
    setScrollPosition(window.pageYOffset)
  }

  return (
    <>
      {render({
        scrollPosition,
      })}
    </>
  )
}

export default ScrollPos
